import { Role } from "../enums/role";
import { Configuration } from "../models/configuration";
import { CurrentUser } from "../models/current-user";
import { Reset } from "./reset";

export class Parameters
{
  static loggedUser: CurrentUser = Reset.currentUser();

  static configuration: Configuration = {
    shownMeasures : []
  };

  static confirmedConsents(): boolean {
    return this.loggedUser.consents.gdprConsent && this.loggedUser.consents.sanitaryConsent && this.loggedUser.consents.emailConfirmed;
  }

  // Trasforma la lista di interi in una lista di Ruoli
  static decodificaRuoli(roles: number[]): Role[] {
    var result: Role[] = [];

    roles.forEach((value, index) => {
      try {
        var role: Role = value as Role;
        result.push(role);
      } catch (e) {

      }
    });

    return result;
  }

  // Trasforma la lista di interi in una lista con il nome dei Ruoli
  static descriviRuoli(roles: number[]): string[] {
    var result: string[] = [];

    roles.forEach((value, index) => {
      try {
        var role: Role = value as Role;
        result.push(Role[role]);
      } catch (e) {
        result.push(`Unknown: ${value}`)
      }
    });

    return result;
  }
}
